<template>
  <el-tooltip content="Sort" placement="top" effect="light">
    <span test-id="sort" class="cursor-pointer" @click="handleSort(sortItem)">
      <sort-icon :sort-direction="sortDirection[sortItem]" />
    </span>
  </el-tooltip>
</template>

<script>
import { sortHandlerMixin } from '@/mixins/useSort.js'

export default {
  name: 'Sort',
  mixins: [sortHandlerMixin],
  components: {
    SortIcon: () => import('@/assets/v2/icons/SortIcon.vue')
  },
  props: {
    sortItem: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style scoped>
>>> .el-tooltip__popper.is-dark,
>>> .el-tooltip__popper.is-light,
>>> .el-tooltip__popper {
  background: white !important;
}
>>> .el-tooltip__popper.is-light {
  background: white !important;
}
</style>
